import axios from 'axios'
import { oidcConfig } from 'Auth/shared/constants/auth'
import { LOCALSTORAGE_IDENTITY_PREFIX } from 'shared/constants/localStorageVariables'

export const getAccessToken = () => {
  const fromStorage = localStorage.getItem(
    `${LOCALSTORAGE_IDENTITY_PREFIX}user:${oidcConfig.authority}:${oidcConfig.client_id}`
  )
  const oidcStorage = JSON.parse(fromStorage ? fromStorage : '{}')
  return oidcStorage.access_token
}

export const setAxiosDefaults = () => {
  const accessToken = getAccessToken()
  axios.defaults.baseURL = window.config.api.url
  axios.defaults.headers.common['x-api-version'] = '1.0'
  axios.defaults.headers.common['Ocp-Apim-Subscription-Key'] =
    window.config.api.subscription
  axios.defaults.headers.common['APIM-BBLCode'] = window.config.bblCode

  setBearerToken(accessToken)
}

export const setBearerToken = (token: string) => {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
